import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const ResourceList = ({ title, items = [], icon: Icon, className = '' }) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <h3 className="text-lg font-semibold text-white flex items-center">
        {Icon && <Icon className="h-5 w-5 text-primary-light mr-2" />}
        {title}
      </h3>
      <ul className="list-none space-y-3">
        {items.map((item) => (
          <li key={item.title} className="flex items-start group">
            <ArrowTopRightOnSquareIcon className="h-4 w-4 text-primary-light mr-2 mt-1 flex-shrink-0" />
            <div>
              <a 
                href={item.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary hover:text-primary-light transition-colors"
              >
                {item.title}
              </a>
              {item.description && (
                <p className="text-gray-400 mt-1 text-sm">{item.description}</p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResourceList; 